var constants = {
    AUTH_SOURCE_KEY: 'amplify-react-auth-source',
    AUTH0: 'auth0',
    GOOGLE: 'google',
    FACEBOOK: 'facebook',
    AMAZON: 'amazon',
    SIGNING_IN_WITH_HOSTEDUI_KEY: 'amplify-signin-with-hostedUI',
};
export default constants;
//# sourceMappingURL=constants.js.map